import { BalanceId, JRPCErrorCode } from "@bb/game-products-ui";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { v4 } from "uuid";

import { socketActions } from "src/store/actions";
import { api } from "src/store/api";

import { ErrorType } from "src/enums";

import { Notification, State } from "./types";
import { getBalanceInsufficientSubtitle } from "./utils";

const STATE: State = {
  errorMessage: "",
  errorType: null,
  notifications: [],
};

export const errorSlice = createSlice({
  name: "error",
  initialState: STATE,
  reducers: {
    errorMessageUpdated: (state, action: PayloadAction<string>) => {
      state.errorMessage = action.payload;
    },
    errorTypeUpdated: (state, action: PayloadAction<ErrorType | null>) => {
      state.errorType = action.payload;
    },
    notificationAdded: (state, action: PayloadAction<Omit<Notification, "id">>) => {
      state.notifications.push({ id: v4(), ...action.payload });
    },
    notificationDismissed: (state, action: PayloadAction<string>) => {
      state.notifications = state.notifications.filter(
        (notification) => notification.id !== action.payload
      );
    },
    notificationsCleared: (state) => {
      state.notifications = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(socketActions.close, () => ({ ...STATE }))
      .addMatcher(api.endpoints.betCreate.matchFulfilled, (state, action) => {
        if (action.payload.error) {
          switch (action.payload.error.code) {
            case JRPCErrorCode.Balance: {
              const balanceId = action.meta.arg.originalArgs.betParams[0]
                .balanceId as BalanceId;

              state.notifications.push({
                id: v4(),
                variant: "balance",
                title: "НЕДОСТАТОЧНО БАЛАНСА",
                subtitle: getBalanceInsufficientSubtitle(balanceId),
              });
              break;
            }
            case JRPCErrorCode.Limit:
              state.notifications.push({
                id: v4(),
                variant: "info",
                title: "НОМИНАЛЫ ИЗМЕНИЛИСЬ",
                subtitle: "Попробуйте еще раз",
              });
              break;
            default:
              state.notifications.push({
                id: v4(),
                variant: "info",
                title: "ПОПРОБУЙТЕ ЕЩЕ РАЗ",
                subtitle: "",
              });
              break;
          }
        }
      })
      .addMatcher(api.endpoints.betCreate.matchRejected, (state) => {
        state.notifications.push({
          id: v4(),
          variant: "info",
          title: "ПОПРОБУЙТЕ ЕЩЕ РАЗ",
          subtitle: "",
        });
      });
  },
});

export const errorActions = {
  ...errorSlice.actions,
};
